"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _DateInput = _interopRequireDefault(require("../DateInput"));

var _CalendarHeader = _interopRequireDefault(require("./CalendarHeader.proptypes"));

var _constant = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var HeaderWrapper = _styledComponents.default.div.withConfig({
  displayName: "CalendarHeader__HeaderWrapper",
  componentId: "sc-10fnrg6-0"
})(["display:flex;align-items:center;width:100%;"]);

var DateWrapper = _styledComponents.default.div.withConfig({
  displayName: "CalendarHeader__DateWrapper",
  componentId: "sc-10fnrg6-1"
})(["display:flex;flex-direction:column;border:", ";background-color:", ";", " ", ""], function (_ref) {
  var theme = _ref.theme,
      borderColor = _ref.borderColor;
  return "1px solid ".concat(theme.colors[borderColor]);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.backgroundColor.default;
}, function (_ref3) {
  var type = _ref3.type,
      isTwoWay = _ref3.isTwoWay,
      partialDivider = _ref3.partialDivider,
      isMobile = _ref3.isMobile,
      selectingReturn = _ref3.selectingReturn,
      modalOpen = _ref3.modalOpen;
  return type === 'depart' ? "\n    border-radius: ".concat(isTwoWay ? '4px 0 0 4px' : '4px', ";\n    border-right: ").concat(isTwoWay && (partialDivider || isMobile && !modalOpen || selectingReturn) && 'none', ";\n\n     ") : "border-radius: 0 4px 4px 0;\n      border-left: ".concat(isTwoWay && !selectingReturn && 'none', ";");
}, function (_ref4) {
  var isMobile = _ref4.isMobile,
      theme = _ref4.theme,
      modalOpen = _ref4.modalOpen;
  return isMobile ? "padding-bottom: ".concat(!modalOpen && theme.space.XSmall, ";\n      width: ").concat(modalOpen ? '100%' : '50%', ";\n      display: ").concat(modalOpen && 'grid', ";\n      grid-template-columns: ").concat(modalOpen && 'repeat(2,minmax(0,50%))', ";") : "\n      & > div {\n        & > div {\n          height: ".concat(_constant.DATEWRAPPER_HEIGHT, ";\n        }\n      }\n      ");
});

var Divider = _styledComponents.default.div.withConfig({
  displayName: "CalendarHeader__Divider",
  componentId: "sc-10fnrg6-2"
})(["width:1px;background-color:", ";padding-top:", ";padding-bottom:", ";background-clip:content-box;height:", ";border-top:", ";border-bottom:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.greyMedium;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.XXXSmall;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.XXXSmall;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.space.semiMedium;
}, function (_ref9) {
  var theme = _ref9.theme;
  return "1px solid ".concat(theme.colors.greyMedium);
}, function (_ref10) {
  var theme = _ref10.theme;
  return "1px solid ".concat(theme.colors.greyMedium);
});

var CalendarHeader = function CalendarHeader(props) {
  var labels = props.labels,
      isTwoWay = props.isTwoWay,
      theme = props.theme,
      isMobile = props.isMobile,
      departConfig = props.departConfig,
      returnConfig = props.returnConfig,
      dateFormatData = props.dateFormatData,
      onDepartClick = props.onDepartClick,
      onReturnClick = props.onReturnClick,
      hideIcon = props.hideIcon,
      partialDivider = props.partialDivider,
      selectingDepart = props.selectingDepart,
      selectingReturn = props.selectingReturn,
      modalOpen = props.modalOpen;

  var _ref11 = labels || {},
      labelDepart = _ref11.labelDepart,
      labelReturn = _ref11.labelReturn;

  var _ref12 = departConfig || {},
      departDate = _ref12.departDate,
      departDateObj = _ref12.departDateObj;

  var _ref13 = returnConfig || {},
      returnDate = _ref13.returnDate,
      returnDateObj = _ref13.returnDateObj;

  var _ref14 = dateFormatData || {},
      shortDaysTranslation = _ref14.shortDaysTranslation,
      date = _ref14.date;

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var enableFontSizeChange = isMobile && !hideIcon;

  var _useState = (0, _react.useState)(_constant.BORDER_COLOR.DEFAULT),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      borderColorDepart = _useState2[0],
      setBorderColorDepart = _useState2[1];

  var _useState3 = (0, _react.useState)(_constant.BORDER_COLOR.DEFAULT),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      borderColorReturn = _useState4[0],
      setBorderColorReturn = _useState4[1];

  (0, _react.useEffect)(function () {
    if (modalOpen) {
      if (selectingDepart) {
        setBorderColorDepart(_constant.BORDER_COLOR.SELECTION);
        setBorderColorReturn(_constant.BORDER_COLOR.DEFAULT);
      }

      if (selectingReturn) {
        setBorderColorReturn(_constant.BORDER_COLOR.SELECTION);
        setBorderColorDepart(_constant.BORDER_COLOR.DEFAULT);
      }
    } else {
      setBorderColorDepart(_constant.BORDER_COLOR.DEFAULT);
      setBorderColorReturn(_constant.BORDER_COLOR.DEFAULT);
    }
  }, [selectingDepart, selectingReturn, modalOpen]);

  var onClickHandler = function onClickHandler(type) {
    if (type === _constant.TYPE.DEPART && onDepartClick) {
      onDepartClick();
    }

    if (type === _constant.TYPE.RETURN && onReturnClick) {
      onReturnClick();
    }
  };

  var getDateWrapper = function getDateWrapper(type, label, d, dateObj) {
    return /*#__PURE__*/_react.default.createElement(DateWrapper, {
      type: type,
      isTwoWay: isTwoWay,
      onClick: function onClick() {
        return onClickHandler(type);
      },
      partialDivider: partialDivider,
      isMobile: isMobile,
      borderColor: type === _constant.TYPE.DEPART ? borderColorDepart : borderColorReturn,
      selectingReturn: selectingReturn,
      modalOpen: modalOpen
    }, /*#__PURE__*/_react.default.createElement(_DateInput.default, {
      id: type,
      label: label,
      shortDaysTranslation: shortDaysTranslation,
      iconFront: type === _constant.TYPE.DEPART && !hideIcon && _constant.ICON.FONT,
      value: d,
      dateObj: dateObj,
      hideBorder: true,
      dateFormat: date.general,
      isOnlyApplyForHotel: partialDivider || enableFontSizeChange,
      alignContentRight: type === _constant.TYPE.RETURN && isMobile && !modalOpen,
      enableFontSizeChange: enableFontSizeChange
    }));
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(HeaderWrapper, null, getDateWrapper('depart', labelDepart, departDate, departDateObj), partialDivider && isTwoWay && /*#__PURE__*/_react.default.createElement(Divider, null), isTwoWay && getDateWrapper('return', labelReturn, returnDate, returnDateObj));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

CalendarHeader.propTypes = _CalendarHeader.default.PropTypes;
CalendarHeader.defaultProps = _CalendarHeader.default.DefaultProps;
var _default = CalendarHeader;
exports.default = _default;